/** @internal */
export const AppPrefix = '1001001';
